<template>
  <div class="child-settings-panels"
       :class="panelsClasses">
    <vue-perfect-scrollbar class="scrollable-area"
                           ref="scrollableContainer">
      <div class="child-settings-panels__container">
        <child-settings-panels-item class="child-settings-panels__panel"
                                    v-for="child in sortedChildren"
                                    :key="child.id"
                                    :child="child"
                                    :constricted="hasOverflow"/>
      </div>
    </vue-perfect-scrollbar>

    <base-scroll-button class="child-settings-panels__button child-settings-panels__button_left"
                        v-if="showScrollBtn"
                        direction="left"
                        @click="scrollLeft"/>

    <base-scroll-button class="child-settings-panels__button child-settings-panels__button_right"
                        v-if="showScrollBtn"
                        direction="right"
                        @click="scrollRight"/>
  </div>
</template>

<script>
  import ChildSettingsPanelsItem from './ChildSettingsPanelsItem.vue'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  export default {
    components: {
      ChildSettingsPanelsItem,
      VuePerfectScrollbar
    },

    data() {
      return {
        hasOverflow: false
      }
    },

    computed: {
      ...mapGetters('children', {
        children: 'get'
      }),

      sortedChildren() {
        return _.sortBy(this.children, 'name')
      },

      showScrollBtn() {
        return this.hasOverflow && this.$mq !== 'mobile' && this.$mq !== 'small'
      },

      panelsClasses() {
        return {
          'child-settings-panels_overflow': this.hasOverflow,
          'child-settings-mobile': this.$mq === 'mobile',
          'small-screen': this.$mq === 'small'
        }
      }
    },

    mounted() {
      window.addEventListener('resize', this.setLayout)
    },

    methods: {
      setLayout() {
        const container = this.$refs.scrollableContainer.$el

        this.hasOverflow = container.scrollWidth > container.clientWidth
      },

      scrollLeft() {
        let scrollableElement = this.$refs.scrollableContainer.$el

        if (!scrollableElement.scrollLeft) {
          return
        }

        let scrollInterval = setInterval(() => {
          if (scrollableElement.scrollLeft <= 0) {
            clearInterval(scrollInterval)
          }

          scrollableElement.scrollLeft -= 70
        }, 10)
      },

      scrollRight() {
        let scrollableElement = this.$refs.scrollableContainer.$el

        let scrollInterval = setInterval(() => {
          let previousScrollValue = scrollableElement.scrollLeft

          scrollableElement.scrollLeft += 70

          // ScrollLeft value can't be greater than the maximum scroll width,
          // that's why if it's the same after the raise, it had reached it's maximum
          if (previousScrollValue === scrollableElement.scrollLeft) {
            clearInterval(scrollInterval)
          }
        }, 10)
      }
    },

    watch: {
      children: {
        handler() {
          if (!this.children.length) {
            return
          }

          this.$nextTick(this.setLayout)
        },
        immediate: true
      }
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.setLayout)
    }
  }
</script>

<style lang="scss" scoped>
  .child-settings-panels {
    position: absolute;
    bottom: 16px;
    left: 85px;
    right: 85px;

    &__container {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    &__panel {
      &:not(:last-child) {
        margin-right: 16px;
      }
    }

    &__button {
      position: absolute;
      top: 50%;

      &_left {
        left: 0;
        transform: translateX(-50%) translateY(-50%);
      }

      &_right {
        right: 0;
        transform: translateX(50%) translateY(-50%);
      }
    }

    &_overflow {
      padding: 0 25px 8px;
      background-color: #fff;
      border-radius: 12px;

      .child-settings-panels__container {
        justify-content: flex-start;
      }

      .child-settings-panels__panel {
        width: 320px;

        &:not(:last-child) {
          margin-right: 36px;
        }
      }

      &.small-screen {
        left: 24px;
      }
    }
  }

  .scrollable-area {
    overflow: auto;
  }

  .child-settings-mobile {
    position: inherit;
    top: 0;
    left: 0;

    .child-settings-panels__container {
      flex-direction: column;
      align-items: center;
    }

    .child-settings-panels__panel {
      margin: 0 0 20px 0;
    }
  }
</style>
